<template>
    <a href="javascript:;" :class="disabled ? 'gray-60' : 'black-link'" @click="emailClicked">
        <slot />
    </a>
</template>

<script>
import EmailMixins from '../../mixins/EmailMixins';
import Feature from 'Services/Feature';
export default {
    mixins: [EmailMixins],
    props: {
        linkedtype: {
            type: String,
            default: '',
            required: true,
        },
        linkedid: {
            type: [Number, Boolean],
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        email: {
            type: String,
            default: '',
        },
    },

    created() {
        const url = new URL(window.location.href);
        const linkedtype = url.searchParams.getAll('emailprocess[linkedtype]')
            ? url.searchParams.getAll('emailprocess[linkedtype]')
            : false;
        const linkedid = url.searchParams.getAll('emailprocess[linkedid]')
            ? url.searchParams.getAll('emailprocess[linkedid]')
            : false;
        if (linkedtype.length > 0 && linkedid.length > 0) {
            if (this.linkedtype === linkedtype && this.linkedid === linkedid) {
                this.emailClicked();
            }
        }
    },
    methods: {
        emailClicked() {
            if (!this.disabled) {
                const prefill =
                    Feature.isEnabled('email-engine') && !this.email ? { checkPrefill: true } : {};
                this.checkEmailProvider({}, prefill, this.email);
            }
        },
    },
};
</script>
